// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3DP0y","select":"Header_select__3aHaz","clinic":"Header_clinic__1q9tR"};